import { render, staticRenderFns } from "./StaticPages.vue?vue&type=template&id=e9756712"
import script from "./StaticPages.vue?vue&type=script&lang=ts"
export * from "./StaticPages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports